"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemList = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _FallbackItem = require("./FallbackItem");
var _ManufacturerLogo = require("./ManufacturerLogo");
var _Swiper = require("./Swiper");
require("swiper/swiper-bundle.min.css");
const ItemList = _ref => {
  let {
    title,
    text,
    manufacturerLink,
    manufacturerLogoUrl,
    currentItemType,
    isMobile,
    onManufacturerLogoClick,
    images,
    image360,
    videos,
    isPreview,
    currentItemIndex,
    imageUrl,
    itemIndexArray,
    onItemChange,
    onItemClick,
    prevItemIndex,
    totalItemCount,
    Image360ItemComponent,
    ImageItemComponent,
    VideoItemComponent,
    imageDisclaimer
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Gallery-ItemList', {
    'cds-Gallery-ItemList--Preview': isPreview
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "galleryItemList",
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_Swiper.Swiper, {
    title: title,
    text: text,
    isMobile: isMobile,
    currentItemIndex: currentItemIndex,
    onManufacturerLogoClick: onManufacturerLogoClick,
    images: images,
    image360: image360,
    videos: videos,
    isPreview: isPreview,
    imageUrl: imageUrl,
    itemIndexArray: itemIndexArray,
    onItemChange: onItemChange,
    onItemClick: onItemClick,
    prevItemIndex: prevItemIndex,
    totalItemCount: totalItemCount,
    key: isMobile ? currentItemType : undefined,
    Image360ItemComponent: Image360ItemComponent,
    ImageItemComponent: ImageItemComponent,
    VideoItemComponent: VideoItemComponent,
    imageDisclaimer: imageDisclaimer
  }), !images && !image360 && !videos && /*#__PURE__*/_react.default.createElement(_FallbackItem.FallbackItem, {
    title: title
  }), isPreview && /*#__PURE__*/_react.default.createElement(_ManufacturerLogo.ManufacturerLogo, {
    onClick: onManufacturerLogoClick,
    manufacturerLink: manufacturerLink || null,
    manufacturerLogoUrl: manufacturerLogoUrl || null,
    title: title
  }));
};
exports.ItemList = ItemList;
//# sourceMappingURL=ItemList.js.map